import { useCurrentStateAndParams } from '@uirouter/react';

import { HelmEventsDatatable } from '@/react/kubernetes/helm/release/ReleaseDetails/HelmEventsDatatable';

import { useAddonReleaseScope } from './queries/useAddonReleaseScope';
import { AddonReleaseGuard } from './AddonReleaseGuard';

export function AddonEventsTab() {
  const { params } = useCurrentStateAndParams();
  const id = String(params.id ?? '');
  const { scope, query, environmentId, namespace } = useAddonReleaseScope(id, {
    showResources: true,
  });

  // With a release, filter to its resources (matching the helm release view);
  // without one, show all events in the namespace so a failing install is
  // debuggable.
  const hasRelease = scope === 'release';

  return (
    <AddonReleaseGuard
      isLoading={scope === 'loading'}
      isError={scope === 'missing'}
    >
      <HelmEventsDatatable
        namespace={namespace}
        releaseResources={query.data?.info?.resources ?? []}
        filterByResources={hasRelease}
        environmentId={environmentId}
        standalone
      />
    </AddonReleaseGuard>
  );
}
